/**
 * 学习乐园 · 狼羊菜过河（game-guohe.js）
 * ============================================================
 * 「逻辑与推理」组新作：两档——经典狼羊菜（默认档）、传教士与野人（进阶）。
 * 船每次由你划，经典局可带一样东西（或空船），传教士局可带 1~2 人。
 *
 * 反馈口径（栏目底线——即时且可解释）：每一渡讲清「谁过了河、两岸现在
 * 有什么、是否安全」；违规一步当场讲「谁吃了谁」并自动退回——惩罚不是
 * 重来，是让你看清为什么这一步不能走。
 *
 * 查一查口径：从当前局面 BFS 现算到对岸的最短路线，给「下一步带谁 +
 * 剩几步」——讲的是状态推理（哪些组合留下会出事），不是背口诀。
 *
 * 成绩口径：不计时，记各题材完成局数与最少步数，全部存本机 localStorage。
 *
 * 冒烟钩子：window.STGuohe 暴露 safeClassic / safeMissionary / bestMove /
 * applyMove 与 state()（{mode, loc, steps}，供冒烟确定性通关）。
 */
(function (global) {
  'use strict';

  var PREF_KEY = 'study-guohe';
  var RECORD_KEY = 'study-guohe-record';

  /* ============ 引擎：纯函数 ============ */

  /* 经典局安全判定：st = {w:0|1, s:0|1, c:0|1, me:0|1}（0=出发岸 1=对岸）。
     你不在的那岸若狼羊同岸或羊菜同岸即翻车。 */
  function safeClassic(st) {
    var away = st.me === 0 ? 1 : 0;
    if (st.w === away && st.s === away) return false;   // 狼吃羊
    if (st.s === away && st.c === away) return false;   // 羊吃菜
    return true;
  }

  /* 传教士局安全判定：st = {m:左岸传教士, w:左岸野人, me:0|1}。
     任一岸传教士比野人少（且有传教士）即出事。右岸按总数 3 反推。 */
  function safeMissionary(st) {
    var ml = st.m, wl = st.w;
    var mr = 3 - ml, wr = 3 - wl;
    if (ml > 0 && wl > ml) return false;
    if (mr > 0 && wr > mr) return false;
    return true;
  }

  // 应用一次经典局渡河：item 为 'w' | 's' | 'c' | null（空船）
  function applyMove(st, item) {
    var n = { w: st.w, s: st.s, c: st.c, me: st.me === 0 ? 1 : 0 };
    if (item) n[item] = n[item === 'w' ? 'w' : item] === 0 ? 1 : 0;
    return n;
  }

  // 应用一次传教士局渡河：dm/dw 为带上的人数（1~2 合计）。船在左岸出发 → 左岸人数减少
  function applyMissionary(st, dm, dw) {
    var dir = st.me === 0 ? -1 : 1;
    return { m: st.m + dir * dm, w: st.w + dir * dw, me: st.me === 0 ? 1 : 0 };
  }

  /* BFS 最短路线：经典局。返回 {item, rest}（下一步带什么 + 之后还差几步），
     无解返回 null（不会发生——两种题材从任何合法局面都有解）。 */
  function bestMoveClassic(st) {
    var seen = {};
    var q = [{ s: st, path: [] }];
    seen[keyC(st)] = 1;
    var items = ['w', 's', 'c', null];
    while (q.length) {
      var cur = q.shift();
      if (cur.s.w === 1 && cur.s.s === 1 && cur.s.c === 1) {
        return cur.path.length ? { item: cur.path[0].item, rest: cur.path.length - 1 } : null;
      }
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (it && cur.s[it] !== cur.s.me) continue;      // 只能带船所在岸的物件
        var nxt = applyMove(cur.s, it);
        if (!safeClassic(nxt)) continue;
        var k = keyC(nxt);
        if (seen[k]) continue;
        seen[k] = 1;
        q.push({ s: nxt, path: cur.path.concat([{ item: it }]) });
      }
    }
    return null;
  }

  function keyC(s) { return s.w + '' + s.s + '' + s.c + '' + s.me; }

  /* BFS 最短路线：传教士局。返回 {dm, dw, rest}。 */
  function bestMoveMissionary(st) {
    var seen = {};
    var q = [{ s: st, path: [] }];
    seen[keyM(st)] = 1;
    var moves = [[1, 0], [0, 1], [2, 0], [0, 2], [1, 1]];
    while (q.length) {
      var cur = q.shift();
      if (cur.s.m === 0 && cur.s.w === 0) {
        return cur.path.length ? { dm: cur.path[0].dm, dw: cur.path[0].dw, rest: cur.path.length - 1 } : null;
      }
      for (var i = 0; i < moves.length; i++) {
        var dm = moves[i][0], dw = moves[i][1];
        var have = cur.s.me === 0 ? { m: cur.s.m, w: cur.s.w } : { m: 3 - cur.s.m, w: 3 - cur.s.w };
        if (dm > have.m || dw > have.w || dm + dw < 1 || dm + dw > 2) continue;
        var nxt = applyMissionary(cur.s, dm, dw);
        if (nxt.m < 0 || nxt.m > 3 || nxt.w < 0 || nxt.w > 3) continue;
        if (!safeMissionary(nxt)) continue;
        var k = keyM(nxt);
        if (seen[k]) continue;
        seen[k] = 1;
        q.push({ s: nxt, path: cur.path.concat([{ dm: dm, dw: dw }]) });
      }
    }
    return null;
  }

  function keyM(s) { return s.m + '' + s.w + '' + s.me; }

  /* ============ UI：挂载与状态 ============ */

  var MODES = [
    { id: 'classic', name: '经典狼羊菜', short: '经典局', hint: '默认档 · 带 1 样或空船' },
    { id: 'missionary', name: '传教士与野人', short: '传教士局', hint: '3 对 3 · 船载 1~2 人' }
  ];

  var ITEM_NAMES = { w: '狼', s: '羊', c: '菜' };

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  var root = null;
  var ui = {};
  var S = {
    mode: 'classic',
    loc: null,          // classic: {w,s,c,me}；missionary: {m,w,me}
    steps: 0, ended: false,
    picked: [],         // 选中待渡的物件（classic 最多 1；missionary 1~2 个人）
    soundOn: true, resetArm: false, resetTimer: null
  };

  function renderModes() {
    var box = ui.levels;
    box.textContent = '';
    for (var i = 0; i < MODES.length; i++) {
      (function (md) {
        var b = el('button', 'st-llk-pack-btn');
        b.type = 'button';
        b.setAttribute('data-mode', md.id);
        b.setAttribute('role', 'radio');
        b.appendChild(el('span', 'st-llk-pack-name', md.name));
        b.appendChild(el('small', 'st-llk-pack-hint', md.hint));
        b.addEventListener('click', function () {
          if (S.mode === md.id) return;
          newGame(md.id);
        });
        box.appendChild(b);
      })(MODES[i]);
    }
  }

  function syncModes() {
    var btns = ui.levels.querySelectorAll('[data-mode]');
    for (var i = 0; i < btns.length; i++) {
      var on = btns[i].getAttribute('data-mode') === S.mode;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
  }

  function startState(mode) {
    return mode === 'classic' ? { w: 0, s: 0, c: 0, me: 0 } : { m: 3, w: 3, me: 0 };
  }

  /* ---- 渲染 ---- */

  function sideList(side) {
    // 返回该岸上的物件/人物 id 列表
    if (S.mode === 'classic') {
      var out = [];
      if (S.loc.w === side) out.push('w');
      if (S.loc.s === side) out.push('s');
      if (S.loc.c === side) out.push('c');
      return out;
    }
    var list = [];
    var m = side === 0 ? S.loc.m : 3 - S.loc.m;
    var w = side === 0 ? S.loc.w : 3 - S.loc.w;
    for (var i = 0; i < m; i++) list.push('m');
    for (var j = 0; j < w; j++) list.push('w');
    return list;
  }

  function renderBoard() {
    var boatSide = S.loc.me;
    ui.left.textContent = '';
    ui.right.textContent = '';
    var mk = function (list, side, box) {
      var seen = {};   // 传教士局同人多个体：按「岸内序号」生成稳定 key，选中态只亮点中的那一个
      for (var i = 0; i < list.length; i++) {
        (function (id) {
          var nth = seen[id] = (seen[id] || 0) + 1;
          var key = id + '#' + nth;
          var b = el('button', 'st-gh-item st-gh-item--' + id, labelOf(id));
          b.type = 'button';
          b.setAttribute('data-item', id);
          b.setAttribute('data-key', key);
          b.disabled = S.ended || side !== boatSide;
          b.classList.toggle('is-picked', pickedIndex(key) >= 0);
          b.addEventListener('click', function () { onItem(id, key); });
          box.appendChild(b);
        })(list[i]);
      }
      if (!list.length) box.appendChild(el('span', 'st-gh-empty', side === boatSide ? '（都在对岸）' : '（空）'));
    };
    mk(sideList(0), 0, ui.left);
    mk(sideList(1), 1, ui.right);
    ui.boat.textContent = boatSide === 0 ? '⛵ 船在出发岸' : '⛵ 船在对岸';
    ui.cross.disabled = S.ended;
    ui.cross.textContent = pickedLabel();
    renderStatus();
  }

  function labelOf(id) {
    if (S.mode === 'classic') return ITEM_NAMES[id];
    return id === 'm' ? '传教士' : '野人';
  }

  function pickedIndex(id) {
    for (var i = 0; i < S.picked.length; i++) { if (S.picked[i] === id) return i; }
    return -1;
  }

  function pickedLabel() {
    if (S.ended) return '本局已结束';
    if (!S.picked.length) return S.mode === 'classic' ? '空船渡河' : '至少带 1 人渡河';
    if (S.mode === 'classic') return '带' + labelOf(S.picked[0].split('#')[0]) + '渡河';
    var dm = 0, dw = 0;
    for (var i = 0; i < S.picked.length; i++) {
      if (S.picked[i].split('#')[0] === 'm') dm++; else dw++;
    }
    var parts = [];
    if (dm) parts.push(dm + ' 个传教士');
    if (dw) parts.push(dw + ' 个野人');
    return '带' + parts.join('和') + '渡河';
  }

  function renderStatus() {
    if (S.ended) return;
    ui.status.className = 'st-status';
    ui.status.textContent = (S.mode === 'classic' ? '经典狼羊菜' : '传教士与野人')
      + ' · 已渡 ' + S.steps + ' 趟 · 点船所在岸的名字选中，再点渡河按钮';
  }

  function renderNote(text, tone) {
    ui.note.textContent = text || '';
    ui.note.className = 'st-llk-note' + (tone ? ' is-' + tone : '');
  }

  function renderRecord() {
    var box = ui.record;
    box.textContent = '';
    var rec = loadRecord();
    for (var i = 0; i < MODES.length; i++) {
      var md = MODES[i];
      var r = rec[md.id];
      var bits = [];
      if (r && r.wins) bits.push(r.wins + ' 局');
      if (r && r.best) bits.push(r.best + ' 趟');
      box.appendChild(recordStat(
        md.short,
        bits.length ? bits.join(' · ') : '还没通关过'
      ));
    }
  }

  function recordStat(label, value) {
    var d = el('div', 'st-llk-stat');
    d.appendChild(el('span', 'st-llk-stat-label', label));
    d.appendChild(el('strong', 'st-llk-stat-value', value));
    return d;
  }

  /* ---- 音效（WebAudio 本地合成） ---- */

  /* 手机外放响度补偿（口径统一，由 scripts/boost-sfx-mobile.mjs 批量写入）：
     手机小喇叭对 500Hz 以下钝感、超短音感知响度低——触屏设备把提示音增益翻倍、
     低于 500Hz 的音移高八度、衰减拉长；桌面/耳机维持原响度。 */
  var SFX_MOBILE = false;
  try {
    SFX_MOBILE = (global.matchMedia && global.matchMedia('(pointer: coarse)').matches) ||
      (global.navigator && global.navigator.maxTouchPoints > 0);
  } catch (e) { /* 检测不可用按桌面处理 */ }
  var actx = null;
  function sfx(kind) {
    if (!S.soundOn) return;
    try {
      var AC = global.AudioContext || global.webkitAudioContext;
      if (!AC) return;
      if (!actx) actx = new AC();
      if (actx.state === 'suspended' && actx.resume) actx.resume();
      var t = actx.currentTime;
      var seq;
      if (kind === 'ok') seq = [[523, 0], [659, 0.07]];
      else if (kind === 'win') seq = [[523, 0], [659, 0.1], [784, 0.2], [1046, 0.3]];
      else if (kind === 'bad') seq = [[196, 0], [185, 0.09]];
      else seq = [[330, 0]];
      for (var i = 0; i < seq.length; i++) {
        var o = actx.createOscillator();
        var g = actx.createGain();
        o.type = 'triangle';
        o.frequency.setValueAtTime(SFX_MOBILE && seq[i][0] < 500 ? seq[i][0] * 2 : seq[i][0], t + seq[i][1]);
        g.gain.setValueAtTime(0.0001, t + seq[i][1]);
        g.gain.exponentialRampToValueAtTime(SFX_MOBILE ? 0.42 : 0.18, t + seq[i][1] + 0.01);
        g.gain.exponentialRampToValueAtTime(0.0001, t + seq[i][1] + (SFX_MOBILE ? 0.2 : 0.14));
        o.connect(g); g.connect(actx.destination);
        o.start(t + seq[i][1]); o.stop(t + seq[i][1] + (SFX_MOBILE ? 0.26 : 0.16));
      }
    } catch (e) { /* 音频不可用静默 */ }
  }

  /* ---- 交互 ---- */

  function onItem(id, key) {
    if (S.ended) return;
    var cap = S.mode === 'classic' ? 1 : 2;
    var pi = pickedIndex(key);
    if (pi >= 0) {
      S.picked.splice(pi, 1);        // 再点一次 = 取消选中的这一个个体
      renderBoard();
      renderNote('把「' + labelOf(id) + '」留下来了。想清楚谁和谁不能单独相处。', '');
      return;
    }
    if (S.picked.length >= cap) {
      renderNote(S.mode === 'classic'
        ? '船一次只能带一样东西（或空船）——先把「' + labelOf(S.picked[0].split('#')[0]) + '」点掉再换。'
        : '船最多载 2 人——先点掉一个再选。', 'bad');
      return;
    }
    S.picked.push(key);
    sfx('sel');
    renderBoard();
    renderNote('选中了「' + labelOf(id) + '」——' + (S.picked.length < (S.mode === 'classic' ? 1 : 2)
      ? '还可以再选，或直接渡河。' : '点渡河按钮出发。'), '');
  }

  function cross() {
    if (S.ended) return;
    if (S.mode === 'missionary' && !S.picked.length) {
      renderNote('传教士局必须有人划船：至少选 1 人上船。', 'bad');
      return;
    }
    var desc;
    if (S.mode === 'classic') {
      var item = S.picked[0] ? S.picked[0].split('#')[0] : null;   // 个体 key「id#序号」取回 id
      var prev = S.loc;
      S.loc = applyMove(S.loc, item);
      S.steps++;
      S.picked = [];
      if (!safeClassic(S.loc)) {
        // 违规：自动退回并讲清谁吃了谁。
        // 判定必须用「移动后」局面：船开走后没人看的是船原来的岸（= 我此刻在岸的对面）；
        // 若先退回再算，会把有人看的岸当成出事岸、把已上船的狼算作留守——岸名与肇事者全反。
        var away = 1 - S.loc.me;
        var culprit = (S.loc.w === away && S.loc.s === away) ? 'w' : 's';
        S.loc = prev;
        S.steps--;
        var msg = culprit === 'w'
          ? '这一步走不得：船一开走，' + (away === 0 ? '出发岸' : '对岸') + '就剩下狼和羊没人看——狼把羊吃了。'
          : '这一步走不得：船一开走，' + (away === 0 ? '出发岸' : '对岸') + '就剩下羊和菜没人看——羊把菜啃了。';
        sfx('bad');
        renderBoard();
        renderNote(msg + '已经替你退回这一步，换个带法。', 'bad');
        return;
      }
      desc = describeClassic(item);
    } else {
      var dm = 0, dw = 0;
      for (var i = 0; i < S.picked.length; i++) {
        if (S.picked[i].split('#')[0] === 'm') dm++; else dw++;
      }
      var prev2 = S.loc;
      S.loc = applyMissionary(S.loc, dm, dw);
      S.steps++;
      S.picked = [];
      if (!safeMissionary(S.loc)) {
        // 判定用「移动后」局面：两岸不可能同时违规（左岸野人多 ⟺ 右岸传教士少，互斥），
        // 先定违规岸的人数再退回——退回后再算会报成刚到达的岸，数字可能是合法的。
        var bad = (S.loc.m > 0 && S.loc.w > S.loc.m) ? 0 : 1;
        var bm = bad === 0 ? S.loc.m : 3 - S.loc.m;
        var bw = bad === 0 ? S.loc.w : 3 - S.loc.w;
        S.loc = prev2;
        S.steps--;
        sfx('bad');
        renderBoard();
        renderNote('这一步走不得：船一开走，' + (bad === 0 ? '出发岸' : '对岸')
          + '就是 ' + bm + ' 个传教士对 ' + bw + ' 个野人——人少的一方要吃亏。已经替你退回，换个带法。', 'bad');
        return;
      }
      desc = describeMissionary(dm, dw);
    }
    sfx('ok');
    renderBoard();
    if (isWin()) { winGame(); return; }
    renderNote(desc, '');
  }

  function describeClassic(item) {
    var here = S.loc.me === 0 ? '出发岸' : '对岸';
    var there = S.loc.me === 0 ? '对岸' : '出发岸';
    var took = item ? '带着「' + ITEM_NAMES[item] + '」' : '空着船';
    return '第 ' + S.steps + ' 趟：你' + took + '到了' + here + '。现在' + here + '有 '
      + namesAt(S.loc.me) + '，' + there + '有 ' + namesAt(1 - S.loc.me) + '——两岸都没人落单出事。';
  }

  function describeMissionary(dm, dw) {
    var here = S.loc.me === 0 ? '出发岸' : '对岸';
    var there = S.loc.me === 0 ? '对岸' : '出发岸';
    var took = [];
    if (dm) took.push(dm + ' 个传教士');
    if (dw) took.push(dw + ' 个野人');
    return '第 ' + S.steps + ' 趟：你带着 ' + took.join('和') + '到了' + here + '。现在' + here
      + '是 ' + countAt(S.loc.me) + '，' + there + '是 ' + countAt(1 - S.loc.me) + '——两岸传教士都不比野人少。';
  }

  function namesAt(side) {
    var list = sideList(side);
    var names = list.map(labelOf);
    return names.length ? names.join('、') : '（空）';
  }

  function countAt(side) {
    var m = side === 0 ? S.loc.m : 3 - S.loc.m;
    var w = side === 0 ? S.loc.w : 3 - S.loc.w;
    return m + ' 个传教士、' + w + ' 个野人';
  }

  function isWin() {
    if (S.mode === 'classic') return S.loc.w === 1 && S.loc.s === 1 && S.loc.c === 1;
    return S.loc.m === 0 && S.loc.w === 0;
  }

  /* ---- 查一查：BFS 现算最短路线，给下一步 + 理由 ---- */

  function checkBoard() {
    if (S.ended) return;
    var hint = S.mode === 'classic' ? bestMoveClassic(S.loc) : bestMoveMissionary(S.loc);
    if (!hint) {
      renderNote('从当前局面算不出安全路线（这不该发生——退回上一步再想想）。', 'bad');
      return;
    }
    var act, why;
    if (S.mode === 'classic') {
      act = hint.item ? '这一趟带「' + ITEM_NAMES[hint.item] + '」' : '这一趟空船回去';
      why = hint.item === 's'
        ? '羊是「谁都不能单独相处」的那一个，把它挪走或带在船上最安全。'
        : '这样走之后两岸都不会留下会出事的组合。';
    } else {
      act = '这一趟带 ' + hint.dm + ' 个传教士、' + hint.dw + ' 个野人';
      why = '这样走之后两岸都是传教士不比野人少。';
    }
    renderNote('查一查（现算的，不是口诀）：' + act + '，之后还差 ' + hint.rest + ' 趟就能全员过岸。'
      + why, 'ok');
  }

  /* ---- 通关与成绩（只存本机） ---- */

  var BEST_STEPS = { classic: 7, missionary: 11 };

  function winGame() {
    S.ended = true;
    sfx('win');
    var rec = loadRecord();
    var cur = rec[S.mode];
    if (!cur || typeof cur !== 'object' || Array.isArray(cur)) cur = { wins: 0, best: 0 };
    if (typeof cur.wins !== 'number') cur.wins = 0;
    if (typeof cur.best !== 'number') cur.best = 0;
    cur.wins++;
    var isRecord = !cur.best || S.steps < cur.best;
    if (isRecord) cur.best = S.steps;
    rec[S.mode] = cur;
    try { localStorage.setItem(RECORD_KEY, JSON.stringify(rec)); } catch (e) { /* 隐私模式静默 */ }
    var optimal = BEST_STEPS[S.mode];
    ui.status.className = 'st-status is-over';
    ui.status.textContent = '完成！' + S.steps + ' 趟全员过岸'
      + (S.steps === optimal ? '——正好是最少的 ' + optimal + ' 趟！'
        : '（最优解是 ' + optimal + ' 趟，你这局多走了 ' + (S.steps - optimal) + ' 趟）');
    renderNote('这题的心法：先挪走「两头都不能留」的那个（羊／传教士要占多数的局先送人），'
      + '剩下的每一步都是「谁不能和谁单独相处」的排除推理。', 'ok');
    renderRecord();
    renderButtons();
  }

  function loadRecord() {
    try {
      var r = JSON.parse(localStorage.getItem(RECORD_KEY) || '{}');
      return r && typeof r === 'object' && !Array.isArray(r) ? r : {};
    } catch (e) { return {}; }
  }

  function resetRecord() {
    if (!S.resetArm) {
      S.resetArm = true;
      renderButtons();
      if (S.resetTimer) clearTimeout(S.resetTimer);
      S.resetTimer = setTimeout(function () { S.resetArm = false; S.resetTimer = null; renderButtons(); }, 3000);
      return;
    }
    S.resetArm = false;
    if (S.resetTimer) { clearTimeout(S.resetTimer); S.resetTimer = null; }
    try { localStorage.removeItem(RECORD_KEY); } catch (e) { /* 隐私模式静默 */ }
    renderRecord();
    renderButtons();
    toast('已重置过河的本机成绩');
  }

  function renderButtons() {
    ui.newBtn.disabled = false;
    ui.resetBtn.disabled = false;
    ui.resetBtn.classList.toggle('is-arm', S.resetArm);
    ui.resetBtn.textContent = S.resetArm ? '再点一次确认重置' : '重置成绩';
  }

  function save() {
    try {
      localStorage.setItem(PREF_KEY, JSON.stringify({ v: 1, mode: S.mode, soundOn: S.soundOn }));
    } catch (e) { /* 存储不可用静默 */ }
  }

  function restorePrefs() {
    try {
      var d = JSON.parse(localStorage.getItem(PREF_KEY) || '{}');
      if (!d || d.v !== 1) return;
      if (d.mode === 'classic' || d.mode === 'missionary') S.mode = d.mode;
      S.soundOn = d.soundOn !== false;
    } catch (e) { /* 忽略脏数据 */ }
  }

  function newGame(mode) {
    S.mode = mode;
    S.loc = startState(mode);
    S.steps = 0;
    S.ended = false;
    S.picked = [];
    S.resetArm = false;
    if (S.resetTimer) { clearTimeout(S.resetTimer); S.resetTimer = null; }
    syncModes();
    renderBoard();
    renderAll();
    renderRecord();
    renderNote(mode === 'classic'
      ? '「经典狼羊菜」：船一次带一样（或空船）。狼和羊、羊和菜不能在你不在时单独相处——点名字选中，再点渡河按钮。'
      : '「传教士与野人」：船载 1~2 人。任何一岸传教士都不能比野人少——点人物选中（可多选），再点渡河按钮。', '');
    save();
  }

  function renderAll() {
    renderButtons();
  }

  function bindSoundPicker() {
    var btns = root.querySelectorAll('[data-st-sound]');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.addEventListener('click', function () {
          S.soundOn = b.getAttribute('data-st-sound') === 'on';
          for (var j = 0; j < btns.length; j++) {
            var on = btns[j] === b;
            btns[j].classList.toggle('is-active', on);
            btns[j].setAttribute('aria-checked', on ? 'true' : 'false');
          }
          save();
        });
      })(btns[i]);
    }
    syncSoundPicker();
  }

  function syncSoundPicker() {
    var btns = root.querySelectorAll('[data-st-sound]');
    for (var i = 0; i < btns.length; i++) {
      var on = (btns[i].getAttribute('data-st-sound') === 'on') === S.soundOn;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
  }

  function toast(msg) {
    if (!ui.saved) return;
    ui.saved.textContent = msg;
    ui.saved.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { ui.saved.hidden = true; }, 2200);
  }

  /* ============ boot ============ */

  function boot() {
    root = document.querySelector('[data-st-game]');
    if (!root) return;
    ui.levels = root.querySelector('[data-st-gh-modes]');
    ui.left = root.querySelector('[data-st-gh-left]');
    ui.right = root.querySelector('[data-st-gh-right]');
    ui.boat = root.querySelector('[data-st-gh-boat]');
    ui.cross = root.querySelector('[data-st-gh-cross]');
    ui.status = root.querySelector('[data-st-status]');
    ui.note = root.querySelector('[data-st-note]');
    ui.record = root.querySelector('[data-st-record]');
    ui.saved = root.querySelector('[data-st-saved]');
    ui.newBtn = root.querySelector('[data-st-new]');
    ui.checkBtn = root.querySelector('[data-st-check]');
    ui.resetBtn = root.querySelector('[data-st-reset]');

    restorePrefs();
    renderModes();
    bindSoundPicker();

    ui.newBtn.addEventListener('click', function () { newGame(S.mode); });
    ui.checkBtn.addEventListener('click', checkBoard);
    ui.resetBtn.addEventListener('click', resetRecord);
    ui.cross.addEventListener('click', cross);

    newGame(S.mode);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }

  /* ============ 冒烟与复用钩子 ============ */

  global.STGuohe = {
    safeClassic: safeClassic,
    safeMissionary: safeMissionary,
    applyMove: applyMove,
    applyMissionary: applyMissionary,
    bestMoveClassic: bestMoveClassic,
    bestMoveMissionary: bestMoveMissionary,
    state: function () {
      return { mode: S.mode, loc: S.loc, steps: S.steps, ended: S.ended, picked: S.picked.slice() };
    }
  };
})(typeof window !== 'undefined' ? window : globalThis);
